import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from "../auth.service";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  username: string = '';

  possibleConnection;
  connectedAs;

  private _subscription;
  private _subscriptionId;


  constructor(
    public authService: AuthService
  ) {
    this.possibleConnection = authService.possibleConnection;
    this._subscription = authService.possibleConnectionChange.subscribe((value) => {
      this.possibleConnection = value;
    });
    this.connectedAs = authService.connectedAs;
    this._subscriptionId = authService.connectedAsChange.subscribe((value) => {
      this.connectedAs = value;
    });
  }

  ngOnInit() {
    this.username = this.authService.session.user['firstname'];
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
    this._subscriptionId.unsubscribe();
  }

  connectionChange() {
    this.authService.addConnection(this.connectedAs);
  }

  logout() {
    this.authService.logout();
  }

}



// WEBPACK FOOTER //
// ./src/app/header/header.component.ts